<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">{{ topTitle }}</div>
      <div class="title--button">
        <myExportExcel
          :excelTitleList="titleList"
          :idsList="exportIdsList"
          :url="OUTSOURCING_EXPORT_URL.STATEMENT"
          :filter="searchData"
          :excelName="'委外对账单'"
        />
        <printViewBtn
          :changeList="changeList"
          :modules="OUTSOURCING_PRINT_MODULES.STATEMENT"
          :printFun="pmgtPurchasesStatementDoc_getCooperativeSupplierPurchaseStatementDocView"
        />
      </div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="searchData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    />
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :checkKey="'purchasesStatementDocId'"
      :keyData="keyData"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    />
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>

    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="173"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    />

    <statement-object-dialog
      :visible.sync="objectDialogVisible"
      :row="objectRow"
      @success="getList"
    />
  </div>
</template>

<script>
import { selcetSetting, updateSetting, _debounce } from '@/utils/myUtils'
import {
  pmgtPurchasesStatementDoc_getCooperativeSupplierPurchaseStatementDocList,
  pmgtPurchasesStatementDoc_getCooperativeSupplierPurchaseStatementDocView,
  pmgtPurchasesStatementDoc_confirmStatement,
  pmgtPurchasesStatementDoc_cancelConfirm,
} from '@/api/myController/outsourcing'
import { OUTSOURCING_PRINT_MODULES } from '@/utils/outsourcingPrint'
import {
  OUTSOURCING_EXPORT_URL,
  buildExportIdsList,
} from '@/utils/outsourcingExport'
import {
  STATEMENT_MODEL_TYPE,
  STATEMENT_MODEL_TYPE_OPTIONS,
  STATEMENT_CONFIRM_STATUS,
  STATEMENT_CONFIRM_STATUS_OPTIONS,
  buildStatementListPayload,
  normalizeStatementRow,
  canConfirmStatement,
  canObjectStatement,
  canCancelStatementConfirm,
} from '@/utils/outsourcingStatement'
import StatementObjectDialog from './components/statement_object_dialog.vue'

export default {
  name: 'outsourcingProduct_statement',
  components: {
    StatementObjectDialog,
  },
  data() {
    return {
      homeKey: 'xt_outsourcing_statement',
      topTitle: '委外对账单',
      OUTSOURCING_PRINT_MODULES,
      OUTSOURCING_EXPORT_URL,
      pmgtPurchasesStatementDoc_getCooperativeSupplierPurchaseStatementDocView,
      htmlDataDialogState: {
        show2: false,
      },
      routeQuery: {},
      listLoading: false,
      columnType: 'columnAll',
      tableBtnList: ['详情', '确认', '异议', '撤销'],
      list: [],
      changeList: [],
      keyData: ['purchasesStatementDocId'],
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      orderParam: {
        asc: false,
        dateAggregateBy: '',
        fieldName: 'createTime',
      },
      searchData: {
        modelType: STATEMENT_MODEL_TYPE.PRODUCT,
        statusSupplierConfirm: null,
        searchString: '',
        purchasesStatementDocNumber: '',
      },
      objectDialogVisible: false,
      objectRow: {},
      operationTitleData: [],
      titleOperationTitleData: [
        {
          name: '业务类型',
          value: 'modelType',
          type: 'buttonList',
          btnList: [
            { name: '产品委外', value: STATEMENT_MODEL_TYPE.PRODUCT },
            { name: '工序委外', value: STATEMENT_MODEL_TYPE.PROCESS },
          ],
        },
        { name: '', type: 'line' },
        {
          name: '确认状态',
          value: 'statusSupplierConfirm',
          type: 'buttonList',
          btnList: [
            { name: '全部', value: null },
            { name: '待确认', value: STATEMENT_CONFIRM_STATUS.PENDING },
            { name: '已确认', value: STATEMENT_CONFIRM_STATUS.CONFIRMED },
            { name: '有异议', value: STATEMENT_CONFIRM_STATUS.OBJECTED },
          ],
        },
        { name: '', type: 'line' },
        { name: '综合查询', value: 'searchString', type: 'text' },
        { name: '搜索', type: 'button' },
        { name: '重置', type: 'button' },
      ],
      titleList: [
        {
          id: 1,
          name: '业务类型',
          value: 'modelType',
          fixedState: false,
          isShow: true,
          dataType: 'customSelect',
          selectOptionList: STATEMENT_MODEL_TYPE_OPTIONS,
          canEdit: false,
          width: 100,
        },
        {
          id: 2,
          name: '账单编号',
          value: 'purchasesStatementDocNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          color: '#409eff',
          width: 140,
        },
        {
          id: 3,
          name: '标题',
          value: 'docName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 160,
        },
        {
          id: 4,
          name: '对账日期',
          value: 'baseStatementDate',
          fixedState: false,
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          width: 110,
        },
        {
          id: 5,
          name: '应付金额(折前)',
          value: 'baseShouldPaymentAmount',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 120,
        },
        {
          id: 6,
          name: '应付金额(折后)',
          value: 'baseShouldPaymentAmountDiscounted',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 120,
        },
        {
          id: 7,
          name: '未付金额',
          value: 'valueUnpaidAmount',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 100,
        },
        {
          id: 8,
          name: '确认状态',
          value: 'statusSupplierConfirm',
          fixedState: false,
          isShow: true,
          dataType: 'customSelect',
          selectOptionList: STATEMENT_CONFIRM_STATUS_OPTIONS,
          canEdit: false,
          width: 100,
        },
        {
          id: 9,
          name: '确认/异议人',
          value: 'baseSupplierConfirmUserName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 110,
        },
        {
          id: 10,
          name: '确认/异议时间',
          value: 'baseSupplierConfirmTime',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 150,
        },
        {
          id: 11,
          name: '异议说明',
          value: 'valueSupplierObjectionRemark',
          fixedState: false,
          isShow: true,
          dataType: 'textarea',
          canEdit: false,
          width: 180,
        },
        {
          id: 12,
          name: '预付款日期',
          value: 'baseExpectedPaymentDate',
          fixedState: false,
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          width: 120,
        },
        {
          id: 13,
          name: '创建时间',
          value: 'createTime',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 150,
        },
        {
          id: 14,
          name: '备注',
          value: 'remark',
          fixedState: false,
          isShow: true,
          dataType: 'textarea',
          canEdit: false,
          width: 140,
        },
      ],
    }
  },
  computed: {
    exportIdsList() {
      return buildExportIdsList(this.changeList, 'purchasesStatementDocId')
    },
  },
  created() {
    this.$root.mainTitleList[this.homeKey] = JSON.parse(
      JSON.stringify(this.titleList)
    )
    this.getList = _debounce(this.getList, 200)
    this.getList()
    this.querySetting()
  },
  methods: {
    buildFilterSearchData() {
      return {
        statusSupplierConfirm: this.searchData.statusSupplierConfirm,
        searchString: this.searchData.searchString,
        purchasesStatementDocNumber:
          this.searchData.purchasesStatementDocNumber || '',
      }
    },
    getList() {
      const modelType = this.searchData.modelType
      if (
        modelType === null ||
        modelType === undefined ||
        modelType === ''
      ) {
        this.$message.warning('请选择业务类型')
        return
      }
      this.listLoading = true
      pmgtPurchasesStatementDoc_getCooperativeSupplierPurchaseStatementDocList(
        buildStatementListPayload({
          modelType,
          searchData: this.buildFilterSearchData(),
          pageParam: this.listQuery,
          orderParam: [this.orderParam],
        })
      )
        .then((res) => {
          const pageData = (res.data && res.data.data) || {}
          this.list = (pageData.dataList || []).map(normalizeStatementRow)
          this.listQuery.total = pageData.totalCount || 0
        })
        .catch(() => {
          this.list = []
          this.listQuery.total = 0
        })
        .finally(() => {
          this.listLoading = false
          this.$refs.myOperate && this.$refs.myOperate.dragSortShow()
        })
    },
    async querySetting() {
      const titleList = await selcetSetting(this.homeKey)
      if (titleList == null) {
        updateSetting(this, this.homeKey, JSON.stringify(this.titleList))
      } else {
        this.titleList = titleList
      }
    },
    titleOperationBtnClick(item, titleData) {
      if (titleData) {
        this.searchData = { ...this.searchData, ...titleData }
      }
      switch (item.name) {
        case '搜索':
          this.listQuery.pageNum = 1
          this.getList()
          break
        case '重置':
          this.searchData = {
            modelType: STATEMENT_MODEL_TYPE.PRODUCT,
            statusSupplierConfirm: null,
            searchString: '',
            purchasesStatementDocNumber: '',
          }
          this.listQuery.pageNum = 1
          this.getList()
          break
        case '产品委外':
        case '工序委外':
        case '全部':
        case '待确认':
        case '已确认':
        case '有异议':
          this.listQuery.pageNum = 1
          this.getList()
          break
        default:
          break
      }
    },
    operationBtnClick(item, titleData) {
      this.titleOperationBtnClick(item, titleData)
    },
    resetClick() {
      this.searchData = {
        modelType: STATEMENT_MODEL_TYPE.PRODUCT,
        statusSupplierConfirm: null,
        searchString: '',
        purchasesStatementDocNumber: '',
      }
      this.listQuery.pageNum = 1
      this.getList()
    },
    openDetail(row) {
      this.routeQuery = row
      this.htmlDataDialogState.show2 = true
    },
    htmlDataDialogClose() {
      this.htmlDataDialogState.show2 = false
      this.getList()
    },
    async btnClick(row, item) {
      switch (item) {
        case '详情':
          this.openDetail(row)
          break
        case '确认':
          this.handleConfirm(row)
          break
        case '异议':
          this.handleObject(row)
          break
        case '撤销':
          this.handleCancel(row)
          break
        default:
          break
      }
    },
    handleConfirm(row) {
      if (!canConfirmStatement(row)) {
        this.$message.warning('当前状态不可确认，请先撤销后再确认')
        return
      }
      this.$confirm('确认该对账单无误？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return pmgtPurchasesStatementDoc_confirmStatement({
            dto: {
              purchasesStatementDocId: row.purchasesStatementDocId,
            }
          })
        })
        .then((res) => {
          if (res.data && res.data.success === false) {
            this.$message.error(res.data.errorMessage || '确认失败')
            return
          }
          this.$message.success('确认成功')
          this.getList()
        })
        .catch(() => {})
    },
    handleObject(row) {
      if (!canObjectStatement(row)) {
        this.$message.warning('当前状态不可提出异议')
        return
      }
      this.objectRow = row
      this.objectDialogVisible = true
    },
    handleCancel(row) {
      if (!canCancelStatementConfirm(row)) {
        this.$message.warning('当前状态不可撤销确认')
        return
      }
      this.$confirm('撤销后将回到待确认，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return pmgtPurchasesStatementDoc_cancelConfirm({
            dto: {
              purchasesStatementDocId: row.purchasesStatementDocId,
            }
          })
        })
        .then((res) => {
          if (res.data && res.data.success === false) {
            this.$message.error(res.data.errorMessage || '撤销失败')
            return
          }
          this.$message.success('已撤销')
          this.getList()
        })
        .catch(() => {})
    },
    cellClickEvent(row, column) {
      if (column.field === 'purchasesStatementDocNumber') {
        this.openDetail(row)
      }
    },
    selectChangeEvent(val) {
      this.changeList = val.records || []
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records || []
    },
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value === val.field && item.name === val.title) {
          item.width = val.renderWidth
        }
      })
    },
    onStart() {},
    onEnd(titleList) {
      this.titleList = titleList
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList))
    },
    isShowClick(titleList) {
      this.titleList = titleList
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList))
    },
    widthClick(titleList) {
      this.titleList = titleList
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList))
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title--font {
  font-size: 25px;
  font-weight: 600;
  color: #1476c3;
}
</style>
